import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import QuickListManager from '../components/QuickListManager';
import { Button } from '../components/ui';

export default function ProgramDefinitionsPage() {
  const [platforms, setPlatforms] = useState([]);
  const [carriers, setCarriers] = useState([]);
  const [tab, setTab] = useState('platforms');

  const fetchAll = useCallback(async () => {
    try {
      const [p, c] = await Promise.all([
        api.get('/sales-invoices/platforms'),
        api.get('/sales-invoices/carriers'),
      ]);
      if (p.data.success) setPlatforms(p.data.data || []);
      if (c.data.success) setCarriers(c.data.data || []);
    } catch (e) { console.error(e); }
  }, []);
  useEffect(() => { fetchAll(); }, [fetchAll]);

  return (
    <div style={{ padding: 16 }}>
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, borderBottom: '1px solid var(--border-secondary)' }}>
        <Button
          variant={tab === 'platforms' ? 'primary' : 'ghost'}
          size="sm"
          onClick={() => setTab('platforms')}
        >E-Ticaret Platformları</Button>
        <Button
          variant={tab === 'carriers' ? 'primary' : 'ghost'}
          size="sm"
          onClick={() => setTab('carriers')}
        >Kargo Firmaları</Button>
      </div>

      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-secondary)', borderRadius: 12, padding: 16 }}>
        {tab === 'platforms' && (
          <QuickListManager
            inline
            open={true}
            title="E-Ticaret Platformu"
            items={platforms}
            apiBase="/sales-invoices/platforms"
            extraFields={[
              { key: 'commission_rate', label: 'Komisyon %', type: 'number', placeholder: 'Komisyon %', parser: (v) => parseFloat(v) || 0 },
            ]}
            onChanged={fetchAll}
          />
        )}
        {tab === 'carriers' && (
          <QuickListManager
            inline
            open={true}
            title="Kargo Firması"
            items={carriers}
            apiBase="/sales-invoices/carriers"
            onChanged={fetchAll}
          />
        )}
      </div>
    </div>
  );
}
